<div class="header">
  <spb-logo [routePath]="['/']"
            [title]="configService.onInternalRoute() ? 'Fondväljaren':''"/>

  @if ((configService.logInState$ | async); as logInState) {
    <div class="menu">
      <span>{{ logInState.name }}</span>
      <button [matMenuTriggerFor]="menu" matButton="text">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  }
  <div style="flex-grow: 1"></div>
  <div style="margin-right: 10px">
    <spb-toggle-button/>
  </div>
</div>

<!-- Add other fancy navigations here -->
<mat-menu #menu="matMenu">
  <button (click)="configService.logout()" mat-menu-item>Logga ut</button>
</mat-menu>
